<template>
    <v-container fluid :class="$vuetify.breakpoint.mobile ? 'mt-3 px-0' : 'mt-12'">
        <match-banner :match="match" />
        <v-row class="mb-5">
            <v-col cols="12" class="mx-0 px-0">
                <v-tabs
                    v-model="tab"
                    centered
                    background-color="#232323"
                    color="white"
                >
                    <v-tabs-slider class="custom-teal" />
                    <v-tab v-for="(item, index) in match.videoUrl ? items.concat([{ name: 'Βίντεο Αγώνα' }]) : items" :key="index" color="white">{{ item.name }}</v-tab>
                </v-tabs>
            </v-col>
        </v-row>
        <v-row v-if="this.match.pdfUrl">
            <v-col cols="12">
                <v-btn style="text-transform: capitalize;" class="secondary-font" @click="downloadStats">
                    <v-icon large class="custom-teal-text mr-2">
                        mdi-cloud-download
                    </v-icon>
                    <span>Στατιστικά Αγώνα</span>
                </v-btn>
            </v-col>
        </v-row>
        <v-row v-if="tab === 0" justify="center" align="center">
            <v-col cols="12" class="justify-center" :style="$vuetify.breakpoint.mobile ? 'display: inline-flex; overflow-x: auto;' : 'display: flex;'">
                <period-score v-if="match.team1 && match.team2" :team1="match.team1" :team2="match.team2" :period-scores-team1="getPeriodPoints(match.team1)" :period-scores-team2="getPeriodPoints(match.team2)" />
            </v-col>
        </v-row>
        <main-match-stats-info v-if="tab === 0" :class="$vuetify.breakpoint.mobile ? '' : 'px-16'" :match="match" />
        <v-row v-if="tab === 0" class="my-5" justify="center" align="start">
            <v-col
                cols="auto"
                style="gap: 24px;"
                :style="$vuetify.breakpoint.mobile ? 'display: inline-flex; overflow-x: auto;' : 'display: flex;'"
            >
                <v-card class="mx-1 px-2 py-2 " style="cursor: pointer; background: #232323;" dark>
                    <v-card-title class="custom-teal-text justify-center my-0 pt-0" style="font-size: 20px; font-weight: bold;">
                        Shooting Chart
                        <v-avatar
                            size="50"
                            class="ml-2"
                            style="background-color: white; border-radius: 10px;"
                        >
                            <img :src="`${assetsUrl}/${match.team1.logo}`" height="40px">
                        </v-avatar>
                    </v-card-title>
                    <v-card-subtitle class="text-subtitle-1">
                        <span style="font-size: 15px;"> {{ match.team1.name }} </span>
                    </v-card-subtitle>
                    <shooting-chart :shots="getShots(match.team1)" />
                </v-card>
                <v-card class="mx-1 px-2 py-2 " style="cursor: pointer; background: #232323;" dark>
                    <v-card-title class="custom-teal-text justify-center my-0 pt-0" style="font-size: 20px; font-weight: bold;">
                        Shooting Chart
                        <v-avatar
                            size="50"
                            class="ml-2"
                            style="background-color: white; border-radius: 10px;"
                        >
                            <img :src="`${assetsUrl}/${match.team2.logo}`" height="40px">
                        </v-avatar>
                    </v-card-title>
                    <v-card-subtitle class="text-subtitle-1">
                        <span style="font-size: 15px;"> {{ match.team2.name }} </span>
                    </v-card-subtitle>
                    <shooting-chart :shots="getShots(match.team2)" />
                </v-card>
            </v-col>
        </v-row>
        <main-match-stats-player v-else-if="tab === 1" :class="$vuetify.breakpoint.mobile ? '' : 'px-16'" :match="match" />
        <v-row v-else-if="tab === 2 && match.videoUrl" class="my-5" :class="$vuetify.breakpoint.mobile ? '' : 'px-16'" justify="center">
            <v-col cols="12" md="10">
                <v-card class=" elevation-5 py-0 my-0" :height="$vuetify.breakpoint.mobile ? '200px' : '700px'">
                    <iframe
                        class="iframe-container"
                        width="100%"
                        height="100%"
                        :src="match.videoUrl"
                        title="Youtube Video"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen
                    />
                </v-card>
            </v-col>
            <v-col cols="12" md="6">
                <main-match-stats-info class="mb-5" :match="match" :mvp="false" />
            </v-col>
            <v-col cols="12" md="6">
                <main-match-stats-player :match="match" :mvp="false" :video="true" />
            </v-col>
            <v-col cols="12">
                <match-stats :match="match" />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import MatchBanner from '@/components/MatchBanner'
    import MainMatchStatsPlayer from '@/components/MainMatchStatsPlayer'
    import MainMatchStatsInfo from '@/components/MainMatchStatsInfo'
    import MatchStats from '@/components/MatchStats'
    import matchService from '@/services/match'
    import momentTimezone from 'moment-timezone'
    import moment from 'moment'
    import ShootingChart from '@/components/ShootingChart'
    import PeriodScore from '@/components/PeriodScore'

    export default {
        components: { MatchBanner, MainMatchStatsPlayer, MainMatchStatsInfo, ShootingChart, PeriodScore, MatchStats },
        data() {
            return {
                tab: null,
                polling: null,
                items: [
                    {
                        name: 'Στατιστικά Αγώνα'
                    },
                    {
                        name: 'Στατιστικά Παιχτών'
                    }
                ],
                match: {},
                assetsUrl: 'https://storage.googleapis.com'
            }
        },
        beforeDestroy() {
            clearInterval(this.polling)
        },
        created() {
            this.fetchMatch(this.$route.params.id).then(() => {
                const start = momentTimezone(this.match.matchDatetime).tz('Europe/Athens')
                const end = momentTimezone(this.match.matchDatetime).tz('Europe/Athens').add(4, 'hours')
                const now = momentTimezone().tz('Europe/Athens')
                if (moment(now).isBetween(moment(start), moment(end))) {
                    setTimeout(() => {
                        this.polling = setInterval(() => {
                            this.fetchMatch(this.$route.params.id)
                        }, 3000)
                    }, 3000)
                } else {
                    this.fetchMatch(this.$route.params.id)
                }
            })
        },
        methods: {
            getPeriodPoints(team) {
                if (!team || !team.players) {
                    return { 1: '-', 2: '-', 3: '-', 4: '-' }
                }
                const periodPoints = {}
                team.players.forEach(player => {
                    if (
                        player.stats &&
                        player.stats.length > 0 &&
                        player.stats[0] &&
                        player.stats[0].periodScore
                    ) {
                        Object.entries(player.stats[0].periodScore).forEach(([period, points]) => {
                            periodPoints[period] = (periodPoints[period] || 0) + points
                        })
                    }
                })
                // Fill missing periods with '-'
                for (let i = 1; i <= 4; i++) {
                    if (periodPoints[i] === undefined) periodPoints[i] = '-'
                }
                return periodPoints
            },
            getShots(team) {
                return team.players.flatMap((player) => {
                    if (player.stats.length === 0 || !player.stats[0].throwPositions) {
                        return []
                    }
                    return player.stats[0].throwPositions.map(shot => ({
                        x: shot.x,
                        y: shot.y,
                        made: shot.made,
                        playerName: player.name,
                        throwStatus: shot.throwStatus
                    }))
                })
            },
            fetchMatch(matchId) {
                return matchService.getMatch(matchId).then(resp => {
                    this.match = resp.data
                })
            },
            downloadStats() {
                window.open(`${this.assetsUrl}/${this.match.pdfUrl}`, '_blank')
            }
        }
    }
</script>

<style scoped>

.mobile-sticky-banner {
    position: sticky;
    top: 80px;
    z-index: 1;
}

.pc-sticky-banner {
    position: sticky;
    top: 60px;
    z-index: 1;
}

.v-tab {
    text-transform: none !important;
    font-weight: bolder;
    font-size: 15px;
    color: #757578 !important;
}

.v-tab::before {
    opacity: 0;
    pointer-events: none;
    position: absolute;
    background-color: transparent;
}

.v-tab--active {
    color: teal !important;
}
</style>
